var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stop_svg__stop_svg__clip0_8312_52863)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6E7D8C",
    stroke: "#6E7D8C",
    strokeWidth: 1.5,
    d: "M6 1.5a4.5 4.5 0 100 9 4.5 4.5 0 100-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 5.144a.343.343 0 01.343-.343h1.714a.343.343 0 01.343.343v1.714a.343.343 0 01-.343.343H5.143a.343.343 0 01-.343-.343V5.144z",
    fill: "#F7FBFF",
    stroke: "#F7FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stop_svg__stop_svg__clip0_8312_52863"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgStop;